import axios from "axios";

const API = axios.create({
  baseURL: "https://ruesicn.azurewebsites.net/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default API;
